import React, { Component } from "react";
import FlipMove from "react-flip-move";
import styled from "styled-components";

import EventCard from "./EventCard";

const EventCardWrapper = styled.div`
  width: 48%;
  margin-bottom: 4%;
  @media screen and (max-width: 48em) {
    width: 100%;
    margin-bottom: 2rem;
  }
`;

const Container = styled(FlipMove)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

class EventCardList extends Component {
  state = {
    activeEvent: ""
  };

  toggleActive(eventId) {
    this.setState(prevState => {
      if (eventId === prevState.activeEvent) {
        return { activeEvent: "" };
      }
      return { activeEvent: eventId };
    });
  }

  isActive(eventId) {
    if (this.state.activeEvent === eventId) {
      return true;
    }
    return false;
  }

  events() {
    const eventsFromToday = this.props.events.filter(
      ({ node }) => new Date(node.date) > new Date()
    );
    return eventsFromToday.map(({ node }) => (
      <EventCardWrapper key={node.id}>
        <EventCard
          toggleActive={() => this.toggleActive(node.id)}
          {...node}
          active={this.isActive(node.id)}
        />
      </EventCardWrapper>
    ));
  }
  render() {
    return (
      <Container duration={300} easing="ease-out">
        {this.events()}
      </Container>
    );
  }
}

export default EventCardList;



// WEBPACK FOOTER //
// ./src/components/Events/EventCardList.js